import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../App.css';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5001';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    if (!email.trim()) {
      setError('Vennligst oppgi e-postadressen din.');
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(`${API_BASE_URL}/api/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim() }),
      });

      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data.error || 'Noe gikk galt. Prøv igjen.');
      }

      setSuccess(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="auth-layout">
        <div className="auth-card">
          <header className="auth-header">
            <span className="auth-badge auth-badge-success">✓</span>
            <h1>Sjekk innboksen din</h1>
            <p>
              Hvis det finnes en konto med e-postadressen <strong>{email}</strong>, 
              har vi sendt en e-post med instruksjoner for å tilbakestille passordet ditt.
            </p>
          </header>
          <Link to="/login" className="button button-primary">
            Tilbake til innlogging
          </Link>
          <footer className="auth-footer">
            <p>
              Finner du ikke e-posten? Sjekk søppelpost-mappen, eller{' '}
              <button
                type="button"
                className="link-button"
                onClick={() => {
                  setSuccess(false);
                  setEmail('');
                }}
              >
                prøv igjen
              </button>
              .
            </p>
          </footer>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-layout">
      <div className="auth-card">
        <header className="auth-header">
          <span className="auth-badge">KI Chat</span>
          <h1>Glemt passord?</h1>
          <p>
            Oppgi e-postadressen din, så sender vi deg en lenke for å tilbakestille passordet.
          </p>
        </header>

        <form className="auth-form" onSubmit={handleSubmit}>
          <label className="auth-label" htmlFor="email">
            E-postadresse
            <input
              id="email"
              name="email"
              type="email"
              className="input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="fornavn@dinbedrift.no"
              autoComplete="email"
              required
            />
          </label>
          {error && <div className="auth-error">⚠️ {error}</div>}
          <button type="submit" className="button button-primary" disabled={loading}>
            {loading ? 'Sender...' : 'Send tilbakestillingslenke'}
          </button>
        </form>

        <footer className="auth-footer">
          <p>
            <Link to="/login">← Tilbake til innlogging</Link>
          </p>
        </footer>
      </div>

      <style>{`
        .link-button {
          background: none;
          border: none;
          color: var(--primary, #f97316);
          cursor: pointer;
          text-decoration: underline;
          padding: 0;
          font: inherit;
        }
        .link-button:hover {
          color: var(--primary-hover, #ea580c);
        }
      `}</style>
    </div>
  );
};

export default ForgotPasswordPage;
